<template>
  <v-dialog
    v-model="optionsDialog"
    persistent
    max-width="500px"
  >
    <v-btn
      slot="activator"
      :small="isMobile"
      color="primary"
      class="ma-0"
      @click="optionsDialog = !optionsDialog"
    >
      Report Options
    </v-btn>
    <v-card>
      <v-toolbar
        card
        dense
      >
        <v-btn
          icon
          @click.native="optionsDialog = false"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Options</v-toolbar-title>
        <v-spacer />
        <v-btn
          text
          color="red"
          @click="$emit('resetOptionsToDefaults')"
        >
          Reset
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <slot />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  components: {

  },
  mixins: [],

  data: () => ({
    optionsDialog: false
  }),

  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.xsOnly
    }
  },

  watch: {

  },

  mounted () {
  },

  created () {

  },

  methods: {

  }
}

</script>

<style lang="scss">

</style>
